import React from 'react';
import { trackEvent } from '../../../../shared/utils/analytics';
import './UserMenu.css';

function UserMenu({ userEmail, onLogout, onHelpClick, onAboutClick, onFeedbackClick, onInviteCodeClick }) {
  const handleLogout = () => {
    trackEvent('logout');
    onLogout();
  };

  return (
    <div className="user-menu text-non-selectable open">
      {onInviteCodeClick && (
        <button type="button" className="user-menu-item text-non-selectable" onClick={onInviteCodeClick}>
          Invite others
        </button>
      )}
      {onHelpClick && (
        <button type="button" className="user-menu-item text-non-selectable" onClick={onHelpClick}>
          Help
        </button>
      )}
      {onAboutClick && (
        <button type="button" className="user-menu-item text-non-selectable" onClick={onAboutClick}>
          About
        </button>
      )}
      {onFeedbackClick && (
        <button type="button" className="user-menu-item text-non-selectable" onClick={onFeedbackClick}>
          Share feedback
        </button>
      )}
      <button className="user-menu-item text-non-selectable" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
}

export default UserMenu;

